import xl from "@/assets/js/src/style/json/variables.json"

export function useScrollTo () {
    return {
        scrollTo: function (elem, smooth = false) {
            if(!elem) {
                window.scrollTo(0, 0)

                return
            }

            let offset = 0
            let mainHeader = document.querySelector('.bs-header-wrapper')
            let scrollHeader = document.querySelector('.scroll-header')
            if (mainHeader && scrollHeader) {
                offset += Math.max(parseInt(mainHeader.offsetTop), parseInt(scrollHeader.offsetTop)) + parseInt(xl.header.offset)
                offset += parseInt(mainHeader.clientHeight)
            }
            let h1 = document.querySelector('h1')
            if (h1) {
                offset += parseInt(window.getComputedStyle(h1).fontSize) * 1.5
            }

            if(smooth) {
                window.scrollTo({top: parseInt(elem.offsetTop) - offset, left: 0, behavior: 'smooth',})
            } else {
                window.scrollTo(0, parseInt(elem.offsetTop) - offset)
            }

            setTimeout(() => {
                window.MAIN_HEADROOM && window.MAIN_HEADROOM.pin()
            })
        },
    }
}